import { useMemo } from 'react';

export const useValidate = (query) => {
  return useMemo(() => {
    if (!query.subCategory && !query.vehicle && !query.reference) {
      return ['subCategory', 'vehicle', 'reference'];
    } else if (!query.reference) {
      if (query.subCategory && !query.vehicle) {
        return ['vehicle', 'reference'];
      } else if (query.vehicle && !query.subCategory) {
        return ['subCategory', 'reference'];
      }
    }

    return [];
  }, [query]);
};
